import { generateChatVariantPacksPriceEditMapKey } from '@/utils/offline-mode';
import {
  OfflineVariantPackPriceEditAdapter,
  PriceEditInfo,
} from '@/adapters/offline-mode';
import { useCallback } from 'react';

export const useOfflinePriceEdits = () => {
  const fetchOfflinePriceEdits = useCallback(
    async (restaurantUUID: string, supplierUUID: string) => {
      const offlineVariantPackPriceEditAdapter =
        new OfflineVariantPackPriceEditAdapter();
      const offlinePriceEdits =
        await offlineVariantPackPriceEditAdapter.fetch();
      const chatKey = generateChatVariantPacksPriceEditMapKey({
        restaurantUUID,
        supplierUUID,
      });
      return offlinePriceEdits ? offlinePriceEdits[`${chatKey}`] : null;
    },
    [],
  );

  const setOfflinePriceEdits = useCallback(
    async (
      restaurantUUID: string,
      supplierUUID: string,
      variantPackUUID: string,
      priceEditInfo: PriceEditInfo,
    ) => {
      const chatKey = generateChatVariantPacksPriceEditMapKey({
        restaurantUUID,
        supplierUUID,
      });
      const offlineVariantPackPriceEditAdapter =
        new OfflineVariantPackPriceEditAdapter();
      let offlinePriceEdits = await offlineVariantPackPriceEditAdapter.fetch();
      if (!offlinePriceEdits) {
        offlinePriceEdits = {};
      }
      if (!offlinePriceEdits[chatKey]) {
        offlinePriceEdits[chatKey] = {};
      }

      offlinePriceEdits[chatKey][variantPackUUID] = priceEditInfo;

      await offlineVariantPackPriceEditAdapter.save(offlinePriceEdits);
      return offlinePriceEdits[chatKey];
    },
    [],
  );

  return {
    fetchOfflinePriceEdits,
    setOfflinePriceEdits,
  };
};
